// src/Redux/Reducer/DashboardReducer/DashboardReducer.js
const initialState = {
  stats: null,
  salesSlip: null,
  purchaseSlip: null,
  loading: false,
  slipLoading: false,
  error: null
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DASHBOARD_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_DASHBOARD_SUCCESS':
      return { ...state, loading: false, stats: action.payload, error: null };
    case 'FETCH_DASHBOARD_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_SALES_SLIP_REQUEST':
      return { ...state, slipLoading: true, error: null };
    case 'FETCH_SALES_SLIP_SUCCESS':
      return { ...state, slipLoading: false, salesSlip: action.payload, error: null };
    case 'FETCH_SALES_SLIP_FAILURE':
      return { ...state, slipLoading: false, error: action.payload };

    case 'FETCH_PURCHASE_SLIP_REQUEST':
      return { ...state, slipLoading: true, error: null };
    case 'FETCH_PURCHASE_SLIP_SUCCESS':
      return { ...state, slipLoading: false, purchaseSlip: action.payload, error: null };
    case 'FETCH_PURCHASE_SLIP_FAILURE':
      return { ...state, slipLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default DashboardReducer;